// extracted by mini-css-extract-plugin
export default {"header":"AdminPeopleView_header__Xld+J","item":"AdminPeopleView_item__Doa-5"};